import React, {useCallback, useMemo} from 'react';
import {connect} from "react-redux";
import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../../../../../misc/utils";
import {getDbFeatureName} from "../../../../helpers/featureHelper";

const SqftOptionsRelatedItemRow = (props) => {
  const {feature, index, style} = props;
  const {featuresMatchedByName} = props;
  const {activeItemIndex, setActiveItemIndex} = props;
  const {itemClickCallback} = props;

  const className = useMemo(() => activeItemIndex === feature ? 'lightbox-option-single lightbox-option-selected' : 'lightbox-option-single', [activeItemIndex, feature]);

  const imageUrl = useMemo(() => feature.thumbnailUrl ? s3FeatureImagePath(feature.thumbnailUrl, THUMBNAIL_SIZES.medium) : feature.customThumbnail, [feature.thumbnailUrl, feature.customThumbnail]);

  const { width, height, depth, parentFeature } = useMemo(() => {
    const width = parseInt(feature.description.substr(feature.description.indexOf('Width') + 6, 3), 10);
    const height = parseInt(feature.description.substr(feature.description.indexOf('Height') + 7, 3), 10);
    const depth = parseInt(feature.description.substr(feature.description.indexOf('Depth') + 6, 3), 10);
    const parentFeature = featuresMatchedByName[0].part;
    return { width, height, depth, parentFeature };
  }, [feature.description, featuresMatchedByName]);

  const handleButtonClick = useCallback((e) => {
    e.preventDefault();
    setActiveItemIndex(feature);
    itemClickCallback(feature, parentFeature, width, height, depth);
  }, [feature, parentFeature, width, height, depth, setActiveItemIndex, itemClickCallback]);

  // Early return for missing thirdPartyAR3DUrls should be placed here, before hooks, if ESLint still complains
  if (!feature.thirdPartyAR3DUrls) {
    console.log(`${feature.sharedFeatureName}.thirdPartyAR3DUrls is empty`, feature.thirdPartyAR3DUrls);
    return null;
  }

  return (
    <div className={className} style={style} key={index}
         onClick={(e) => handleButtonClick(e, feature, parentFeature, width, height, depth)}>
      <div className="upper-image">
        {imageUrl ? <img src={imageUrl} className="accItem-image__block-img" alt=""/> : null}
      </div>
      <div className="upper-content">
        <div className="lightbox-title">
          {getDbFeatureName(feature)}
        </div>
        <div className="lightbox-description-text-rectangular">
          <span>W {width ? width : ''} | </span>
          <span>H {height ? height : ''} | </span>
          <span>D {depth ? depth : ''}</span>
          {/*<span>{feature.description}</span>*/}
          {/*<FormattedMessage id="sqft.navigation.radius.radiusItem"/>*/}
        </div>
      </div>
    </div>

  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {visualizersLoaded} = store.serverState;
  const {windowHeight, isMobile} = store.serverState;

  return {
    menuOpened,
    windowHeight,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftOptionsRelatedItemRow);
